export default __webpack_public_path__ + "static/media/adding_prospects_step1.4ee5937d.png";